import { registerPlugin } from '@capacitor/core';

import type { FirebaseAuthBridgeInterface } from '@/plugins/FirebaseAuthBridge/definitions';

const FirebaseAuthBridge = registerPlugin<FirebaseAuthBridgeInterface>('FirebaseAuthBridge', {
  web: () => import('./web').then((m) => new m.FirebaseAuthBridgeWeb()),
});

export * from './definitions';
export { FirebaseAuthBridge };
